export default __webpack_public_path__ + "static/media/15.340799e9.jpg";